;<template>
  <svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.8 1.39922H6L4.8 0.199219H1.2C0.54 0.199219 0.00599999 0.739219 0.00599999 1.39922L0 8.59922C0 9.25922 0.54 9.79922 1.2 9.79922H10.8C11.46 9.79922 12 9.25922 12 8.59922V2.59922C12 1.93922 11.46 1.39922 10.8 1.39922ZM10.8 8.59922H1.2V2.59922H10.8V8.59922Z"
      fill="currentColor"
    />
  </svg>
</template>
